import React from 'react';
import { Package } from 'lucide-react';
import { ProductResource } from '../types';
import ProductCard from './ProductCard';
import LoadingSpinner from './LoadingSpinner';

interface ProductListProps {
  products: ProductResource[];
  loading: boolean;
  search: string;
}

const ProductList: React.FC<ProductListProps> = ({ products, loading, search }) => {
  if (loading) {
    return (
      <div className="bg-white shadow rounded-lg p-8">
        <LoadingSpinner size="md" text="Loading products..." />
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-8 text-center">
        <Package className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No products found</h3>
        <p className="mt-1 text-sm text-gray-500">
          {search ? `No products match "${search}"` : 'This company has no products yet.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default ProductList;
